import React from 'react';

export const Faq: React.FC = () => {
  return (
    <section className="section-dark" style={{ paddingBottom: 'var(--spacing-section)' }} id="faq">
      <div className="container">
        <div className="section-header" style={{ textAlign: 'center' }}>
          <div className="eyebrow">Developer FAQ</div>
          <h3 className="display-large" style={{ marginTop: 12 }}>Frequently Asked Questions</h3>
        </div>

        <div className="faq-grid">
          <div className="faq-item">
            <h4 className="faq-q">How does Draway Auth compare to Auth0 and Clerk?</h4>
            <p className="faq-a">
              Auth0 imposes steep enterprise pricing cliffs as soon as you need custom domains or MFA, while Clerk relies heavily on front-end components that constrain UI customization. Draway Auth is built developer-first with hardened headless APIs, true FIDO2 passkeys, zero MAU price walls, and complete tenant isolation.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-q">Can we migrate existing users without password resets?</h4>
            <p className="faq-a">
              Yes. Draway provides a migration endpoint supporting bcrypt, Argon2, PBKDF2, and SCrypt password hash ingestion, as well as a seamless &quot;lazy migration&quot; hook to port users upon their next successful login.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-q">How does WhatsApp Auth &amp; OTP verification work?</h4>
            <p className="faq-a">
              Draway Auth integrates directly with official WhatsApp Business APIs. Users receive instant, end-to-end encrypted 6-digit verification codes and one-tap login buttons directly in WhatsApp, delivering 98%+ open rates and bypassing telecom SMS carrier delays or spam filtering.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-q">Are WebAuthn Passkeys supported across all devices?</h4>
            <p className="faq-a">
              Yes. Draway Auth integrates <code>@simplewebauthn</code> v13, which supports Apple TouchID/FaceID, Google Password Manager on Android/Chrome, Windows Hello, and external FIDO2 hardware keys (YubiKeys) across all modern browsers.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-q">Can Draway Auth be self-hosted or run on-prem?</h4>
            <p className="faq-a">
              Yes. Enterprise customers can deploy the containerized Draway Auth API and isolated database within their own AWS/GCP/Azure VPC or on bare-metal Kubernetes clusters with complete data sovereignty.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
